import React from "react";
import PropTypes from "prop-types";

const Tabs = ({ tabs, activeTab, onTabClick }) => {
  const handleTabClick = (tabId, event) => {
    event.preventDefault(); // Prevent default anchor click behavior
    if (tabId !== "disabled") {
      onTabClick(tabId);
    }
  };

  return (
    <div className="w-full">
      <div className=" text-sm font-medium text-center text-gray-500 border-b border-gray-200 dark:text-gray-400 dark:border-gray-700">
        <ul className="flex flex-wrap -mb-px ">
          {tabs.map((tab) => (
            <li key={tab.id} className={tab.disabled ? "" : "me-2"}>
              <a
                className={`inline-block p-4 border-b-2 rounded-t-lg cursor-pointer text-black ${
                  tab.disabled
                    ? "text-black cursor-not-allowed "
                    : `hover:text-black/45  ${
                        activeTab === tab.id && "font-bold"
                      }`
                }`}
                onClick={(event) => handleTabClick(tab.id, event)}
                aria-current={activeTab === tab.id ? "page" : undefined}
              >
                {tab.label}
              </a>
            </li>
          ))}
        </ul>
      </div>
      <div className="p-4">
        {tabs.find((tab) => tab.id === activeTab)?.content}
      </div>
    </div>
  );
};

Tabs.propTypes = {
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      href: PropTypes.string,
      disabled: PropTypes.bool,
      content: PropTypes.node.isRequired, // Content for each tab
    })
  ).isRequired,
  activeTab: PropTypes.string.isRequired,
  onTabClick: PropTypes.func.isRequired,
};

export default Tabs;
